import React from 'react';
import SectionUnlock from '../components/SectionUnlock';
import FlippingCard from '../components/FlippingCard';
import { projects } from '../data/sections';

const ProjectsSection = ({ unlockedSections }) => {
  return (
    <section id="projects" className="py-20 bg-gray-50 relative">
      <SectionUnlock sectionId="projects" unlockedSections={unlockedSections}>
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">Hackathon Projects</h2>
            <p className="text-xl text-gray-600">
              Click on each card to explore my hackathon achievements and technical innovations
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {projects.map((project, index) => (
              <FlippingCard key={index} project={project} />
            ))}
          </div>
        </div>
      </SectionUnlock>
    </section>
  );
};

export default ProjectsSection;